import {
  entityKey,
  sideKey,
  statusKey,
  yesNoKey,
} from '../../../lib/shared-value-keys';

export const caseHistoryKey = [
  { label: 'Case ID', varName: 'CRID' },
  { label: 'Open Date', varName: 'StatusDate', valueMask: 'date' },
  { label: 'Status', varName: 'StatusName' },
];

export const accountInfoKey = [
  { label: 'Client Name', varName: 'ClientFullName' },
  { label: 'Rep Code', varName: 'RepCode' },
  { label: 'Rep Name', varName: 'RepName' },
  { label: 'Unit', varName: 'UnitID' },
  { label: 'RB Processed Date', varName: 'ProcessedDate', valueMask: 'date' },
  {
    label: 'Status',
    varName: 'ReviewStatus',
    key: statusKey,
  },
  { label: 'Reviewer ID', varName: 'ReviewerID' },
];
export const accountKey = [
  {
    label: 'Account #',
    varSet: 'Account',
    varName: 'AccountNumDisplay',
    decryptTarget: 'EncryptedAccountID',
  },
  {
    label: 'Opened',
    varSet: 'Account',
    varName: 'OpenDate',
    valueMask: 'date',
  },
  {
    label: 'Balance',
    varSet: 'Account',
    varName: 'Balance',
    valueMask: 'currency',
  },
  { label: 'Account Type', varSet: 'Display', varName: 'AccountType' },
  { label: 'Registration', varSet: 'Display', varName: 'Registration' },
  { label: 'Tax Status', varSet: 'Display', varName: 'TaxStatus' },
  {
    label: 'Employee Owned',
    varSet: 'Account',
    varName: 'EmployeeOwned',
    key: yesNoKey,
  },
  { label: 'ROA Number', varSet: 'Account', varName: 'ROANumber' },
  {
    label: 'LOI Number',
    varSet: 'Account',
    varName: 'LOINumber',
  },
  {
    label: 'Compensation Type',
    varSet: 'Account',
    varName: 'CompType',
    key: {
      C: 'Commission',
      F: 'Fee',
    },
  },
  {
    label: 'Work/Application #',
    varSet: 'Account',
    varName: 'WorkID',
  },
  {
    label: 'Rep Company',
    varSet: 'Trade',
    varName: 'RepCompany',
  },
];
export const suitabilityKey = [
  {
    label: 'Entity Type',
    varSet: 'AccountHolder',
    varName: 'EntityType',
    key: entityKey,
  },
  { label: 'SSN/TIN', varSet: 'AccountHolder', varName: 'MaskedSSN' },
  { label: 'Age', varSet: 'AccountHolder', varName: 'Age' },
  { label: 'State of Residence', varSet: 'Display', varName: 'ResidentState' },
  {
    label: 'Liquid Net Worth',
    varSet: 'AccountHolder',
    varName: 'LiquidNetWorthDisplay',
  },
  {
    label: 'Net Worth',
    varSet: 'AccountHolder',
    varName: 'NetWorthDisplay',
  },
  {
    label: 'Income',
    varSet: 'AccountHolder',
    varName: 'IncomeDisplay',
  },
  {
    label: 'Tax Bracket',
    varSet: 'AccountHolder',
    varName: 'TaxBracketSource',
  },
  { label: 'Objective', varSet: 'Account', varName: 'ObjectiveDisplay' },
  { label: 'Risk Tolerance', varSet: 'Account', varName: 'RiskTolerance' },
  { label: 'Time Horizon', varSet: 'Account', varName: 'TimeHorizonDisplay' },
  {
    label: 'Liquidity Needs',
    varSet: 'AccountHolder',
    varName: 'LiquidityNeedsDisplay',
  },
];
export const transactionHistoryKey = [
  {
    label: 'Account Number',
    varName: 'AccountNumDisplay',
  },
  {
    label: 'Trade Date',
    varName: 'TradeDate',
    valueMask: 'date',
  },
  { label: 'Side ', varName: 'Side', key: sideKey },
  { label: 'Product Type', varName: 'ProductType' },
  { label: 'Security ID', varName: 'SecID' },
  { label: 'Product Name', varName: 'ProductName' },
  {
    label: 'Amount ',
    varName: 'Amount',
    valueMask: 'currency',
  },
  { label: 'Rep Code', varName: 'RepCode' },
  {
    label: 'Commission Dollars ',
    varName: 'CommissionDollars',
    valueMask: 'currency',
  },
];
export const accountHoldingsKey = [
  { label: 'Product Type', varName: 'SecType' },
  { label: 'Symbol/Code', varName: 'Symbol' },
  { label: 'Name', varName: 'Name' },
  { label: 'Carrier', varName: 'Carrier' },
  { label: 'Last Purchase', varName: 'UpdateDate', valueMask: 'date' },
  { label: '# Shares', varName: 'Quantity' },
  { label: 'Current Value', varName: 'CurrentValue', valueMask: 'currency' },
];
export const recentActivityKey = [
  { label: 'Score Class', varName: 'ScoreClass' },
  { label: 'Activity Date', varName: 'TradeDate', valueMask: 'date' },
  { label: 'Product Type', varName: 'ProductType' },
  { label: 'Symbol', varName: 'Symbol' },
  { label: 'Product Name', varName: 'ProductType' },
  { label: 'Amount', varName: 'Amount', valueMask: 'currency' },
  { label: 'Commission', varName: 'CommissionDollars', valueMask: 'currency' },
];
export const accountReviewKey = [
  {
    label: 'Date Updated',
    varName: 'DateUpdated',
    valueMask: 'date',
  },
  {
    label: 'Status',
    varName: 'NewStatus',
    key: statusKey,
  },
  {
    label: 'Reviewer ID',
    varName: 'ReviewerID',
  },
];
export const accountHistoryKey = [
  {
    label: 'RB Processed Date',
    varName: 'ProcessedDate',
    valueMask: 'date',
  },
  {
    label: 'Score Class',
    varName: 'ScoreClass',
  },
  {
    label: 'Status',
    varName: 'ReviewStatus',
    key: statusKey,
  },
  {
    label: 'Client Name',
    varName: 'ClientFullName',
  },
  {
    label: 'Alert Count',
    varName: 'AlertCount',
  },
  {
    label: 'Last Activity Date',
    varName: 'LastActivityDate',
    valueMask: 'date',
  },
  {
    label: 'Account Balance',
    varName: 'AccountBalance',
    valueMask: 'currency',
  },
  {
    label: 'Reviewer ID',
    varName: 'ReviewerID',
  },
  {
    label: 'Review Date',
    varName: 'ReviewDate',
    valueMask: 'date',
  },
];
export const preTradeAccordionKey = [
  {
    label: 'Risk Tolerance',
    varName: 'RiskTolerance',
  },
  {
    label: 'Investment Objective',
    varName: 'InvestmentObjective',
  },
  {
    label: 'Liquidity Importance',
    varName: 'LiquidityImportance',
  },
  {
    label: 'Investment Advice',
    varName: 'InvestmentAdvice',
  },
  {
    label: 'Fee Sensitivity',
    varName: 'FeeSensitivity',
  },
  {
    label: 'Investor Involvement',
    varName: 'InvestorInvolvement',
  },
  {
    label: 'CRS Delivered',
    varName: 'CRSForm',
  },
];
